import { IconProps } from '../types';

function ClockClockwiseSolidIcon({ className, id }: IconProps) {
  return (
    <svg
      id={id}
      xmlns="http://www.w3.org/2000/svg"
      className={className || 'w-4 h-4'}
      fill="currentColor"
      viewBox="0 0 20 20"
    >
      <path d="M17,3c-.553,0-1,.448-1,1v.709c-2.466-2.797-6.648-3.571-10-1.637-1.851,1.068-3.174,2.793-3.728,4.857-.553,2.064-.269,4.22.799,6.071,1.48,2.563,4.175,3.998,6.942,3.998,1.356,0,2.729-.345,3.986-1.069.479-.276.643-.888.366-1.366-.277-.479-.89-.643-1.366-.366-2.866,1.653-6.542.668-8.196-2.196-.802-1.388-1.015-3.005-.6-4.553.415-1.548,1.407-2.842,2.795-3.643,2.5-1.445,5.618-.876,7.471,1.196h-.471c-.553,0-1,.448-1,1s.447,1,1,1h3c.553,0,1-.448,1-1v-3c0-.552-.447-1-1-1Z" />
      <path d="M9.05,10.249c.015.058.024.117.049.171.025.053.064.098.099.147.042.059.079.117.132.166.011.01.015.024.027.034l3.064,2.571c.188.157.415.234.642.234.286,0,.569-.121.767-.357.355-.423.3-1.054-.123-1.408l-2.707-2.272v-3.534c0-.552-.448-1-1-1s-1,.448-1,1v4c0,.015.008.027.009.042.003.071.024.138.042.207Z" />
    </svg>
  );
}

export default ClockClockwiseSolidIcon;
